import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query teamsPagination($page: Int, $pageSize: Int) {
  teamsPagination(page: $page, pageSize: $pageSize) {
    teams {
      id
      name
      description
      activitySearchTeams,
      activitySearchTeamIds,
      visibleCasesCount
      overseers {
        id
        fullName
      }
      operators {
        id
        fullName
      }
      requestTypePriorities {
        id
        channel {
          id
        }
        requestType{
          id
        }
      }
    }
    totalCount
    pageSize
  }
}`;

function getTeamsPagination(page, pageSize) {
  return apollo.client.query({
    query,
    variables: {
      page,
      pageSize,
    },
    fetchPolicy: 'network-only',
  }).then((res) => res.data.teamsPagination);
}

export default getTeamsPagination;
